import React, { useState, useEffect } from 'react';
import ProgressContainer from './styles';
import { LinearProgress, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const Progress = ({ limit, title }) => {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		const timer = setInterval(() => {
			setProgress(oldProgress => {
				if (oldProgress === 99) {
					return 0;
				}
				const diff = Math.random() * 10;
				return Math.min(oldProgress + diff, limit);
			});
		}, 100);

		return () => {
			clearInterval(timer);
		};
	}, [limit]);

	return (
		<ProgressContainer>
			<Typography className="progress__title">{title}</Typography>
			<LinearProgress variant="buffer" value={progress} />
		</ProgressContainer>
	);
};

export default Progress;

Progress.propTypes = {
	limit: PropTypes.string.isRequired,
	title: PropTypes.string
};

Progress.defaultProps = {
	limit: 100,
	title: ''
};
